<script lang="ts">
  import type {Station} from "../../models/station-detail.interface";

  export let facets = [];
  export let facetCategory = "";
  export let station: Station;

  const MAX_VISIBLE_IDS = 2;

  let expandedSections = new Set();

  function toggleSection(event, sectionKey) {
    event.stopPropagation();
    if (expandedSections.has(sectionKey)) {
      expandedSections.delete(sectionKey);
    } else {
      expandedSections.add(sectionKey);
    }
    expandedSections = expandedSections;
  }

</script>

{#if facets.length > 0}
  <div class="station-facets">
    <i class="bi bi-card-checklist me-1" aria-hidden="true"></i>
    <div class="facet-badge-container">
      {#each facets.slice(0, expandedSections.has(`${facetCategory}-${station.id}`) ? undefined : MAX_VISIBLE_IDS) as facet}
                    <span class="facet-badges" title={`${facetCategory}: ${facet.type}`}>
                      <span class="facet-type">{facet.type}</span>
                      {#if facet.value}
                        :<span class="facet-value">{facet.value}</span>
                      {/if}
                    </span>
      {/each}
      {#if facets.length > MAX_VISIBLE_IDS}
        <button
          class="btn btn-link btn-sm expand-btn"
          on:click={(e) => toggleSection(e, `${facetCategory}-${station.id}`)}
          aria-expanded={expandedSections.has(`${facetCategory}-${station.id}`)}
        >
          {expandedSections.has(`${facetCategory}-${station.id}`)
            ? "less"
            : `+${facets.length - MAX_VISIBLE_IDS}`}
        </button>
      {/if}
    </div>
  </div>
{/if}

<style>
    .station-facets {
        display: flex;
        align-items: flex-start;
    }

    .facet-badge-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px;
        flex: 1;
    }

    .facet-badges {
        display: inline-flex;
        align-items: center;
        gap: 2px;
        background-color: #f8f9fa;
        padding: 2px 5px;
        border-radius: 3px;
        border: 1px solid #e9ecef;
    }

    .facet-type {
        color: #6c757d;
        font-size: 0.65rem;
        font-weight: 500;
        flex-shrink: 0;
    }

    .facet-value {
        font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
        color: #495057;
        font-weight: 500;
        font-size: 0.7rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .expand-btn {
        padding: 0;
        font-size: 0.7rem;
        color: #007ec6;
        text-decoration: none;
        margin-left: 2px;
    }

    .expand-btn:hover {
        text-decoration: underline;
    }

</style>
